import { type LodgingData, CheckInTimeEnum } from "@b2bportal/lodging-api";
import { LodgingAddressEnum } from "@hopper-b2b/types";
import { convertTo12HourFormat } from "@/utils/format";

export const getLodgingAddress = (lodging: LodgingData) => {
  if (lodging.address.LodgingAddress === LodgingAddressEnum.Exact) {
    return lodging.address.line1;
  }
  return lodging.city;
};

export const getLodgingCheckInTime = (lodging: LodgingData) => {
  if (
    lodging.checkInInstructions?.checkInTime?.CheckInTime ===
    CheckInTimeEnum.Anytime
  ) {
    return convertTo12HourFormat("00:00");
  }
  const time =
    lodging.checkInInstructions?.checkInTime?.checkInTimeFrom ?? "00:00";
  return convertTo12HourFormat(time);
};

export const getLodgingCheckOutTime = (lodging: LodgingData) => {
  const time = lodging.checkInInstructions?.checkOutTime ?? "10:00";
  return convertTo12HourFormat(time);
};
